export default "__VITE_ASSET__Dph_Oany__"